import styled from 'styled-components'
import Flex from 'Components/Flex'
import BuildingAutoComplete from 'Components/BuildingAutoComplete'
import { BREAK_POINT_SM } from '@CSSVars/variables'
import { OUTLINE_COLOR, CLICKABLE_COLOR } from '@CSSVars/colors'


export const _BuildingListContainer = styled.div`
  display: -ms-grid;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;

  > div{
    display: inline-block;
    position: relative;
    margin: 0;
  }
`


export const _ClickableFlex = styled(Flex)`
  margin-top: 24px;
  > div:nth-child(odd) {
    color: ${CLICKABLE_COLOR};
    &:hover {
      cursor: pointer;
    }
  }
  > div:nth-child(2) {
    padding: 0 12px;
    color: ${OUTLINE_COLOR};
  }
`

export const _BuildingAutoComplete = styled(BuildingAutoComplete)`
  max-width: 292px;
  border: 1px solid ${OUTLINE_COLOR};
  margin: 12px 0 24px 0;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: 100%;
  }
`
